import { Theme } from '@emotion/react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { SxProps } from '@mui/system';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    marginTop: '70px',
  },
  skeleton: {
    width: '100%',
    height: '60px',
  },
};

export function TableSkeleton() {
  return (
    <Box sx={customStyles.root}>
      {[...Array(3).keys()].map((index) => (
        <Skeleton
          animation='wave'
          key={`skeleton-${index}`}
          sx={customStyles.skeleton}
        />
      ))}
    </Box>
  );
}
